import { CONFIGURATION_STATUS, LEVEL, PROCESS } from 'src/shared/constants/constants'
import { Option } from 'src/shared/form/control'

// translation utils
const getDefaultAllFilterLabel = (getMessage: (key: string, params?: Array<string | number>) => string): string =>
  getMessage('label.configuration.filter.value.all')

// milestone config translations
export const getTranslationForMilestoneResponsibleType = (
  getMessage: (key: string, params?: Array<string | number>) => string,
  value: Option['value'],
): string => {
  if (value === null) {
    return getDefaultAllFilterLabel(getMessage)
  }

  return getMessage(`label.milestone.responsible.${value}`)
}

export const getTranslationForMilestoneType = (
  getMessage: (key: string, params?: Array<string | number>) => string,
  value: Option['value'],
): string => {
  if (value === null) {
    return getDefaultAllFilterLabel(getMessage)
  }

  return getMessage(`label.milestone.type.${value}`)
}

export const getTranslationForMilestoneFrequency = (
  getMessage: (key: string, params?: Array<string | number>) => string,
  value: Option['value'],
): string => {
  if (value === null) {
    return getDefaultAllFilterLabel(getMessage)
  }

  return getMessage(`label.milestone.config.frequency.${value}`)
}

// criteria config translations
export const getTranslationForCriteriaType = (
  getMessage: (key: string, params?: Array<string | number>) => string,
  value: Option['value'],
): string => {
  if (value === null) {
    return getDefaultAllFilterLabel(getMessage)
  }

  return getMessage(`label.${(value as string).toLowerCase()}.criteria`)
}

export const getTranslationForApplicationType = (
  getMessage: (key: string, params?: Array<string | number>) => string,
  value: Option['value'],
  allApplicationTypeOptions: Option[],
): string => {
  if (value === null) {
    return getDefaultAllFilterLabel(getMessage)
  }

  const currentOption = allApplicationTypeOptions.find((opt) => opt.value === value)

  if (!currentOption) {
    return ''
  }

  return getMessage(currentOption.label)
}

// feature config translations
export const getTranslationForFeatureType = (
  getMessage: (key: string, params?: Array<string | number>) => string,
  value: Option['value'],
  allFeatureTypeOptions: Option[],
): string => {
  if (value === null) {
    return getDefaultAllFilterLabel(getMessage)
  }

  const currentOption = allFeatureTypeOptions.find((opt) => opt.value === value)

  return currentOption?.label ?? ''
}

// shared config translations
export const getTranslationForLevel = (
  getMessage: (key: string, params?: Array<string | number>) => string,
  value: Option['value'],
): string => getMessage(`label.level.${value}`)

export const getTranslationForStatus = (
  getMessage: (key: string, params?: Array<string | number>) => string,
  value: Option['value'],
): string => {
  switch (value) {
    case null:
      return getDefaultAllFilterLabel(getMessage)
    case CONFIGURATION_STATUS.ACTIVE:
      return getMessage('label.active')
    case CONFIGURATION_STATUS.INACTIVE:
      return getMessage('label.inactive')
    default:
      return ''
  }
}

export const getTranslationForProcess = (
  getMessage: (key: string, params?: Array<string | number>) => string,
  value: Option['value'],
): string => {
  switch (value) {
    case null:
      return getDefaultAllFilterLabel(getMessage)
    case PROCESS.PF_KAP:
      return getMessage('label.process.PF_KAP')
    case PROCESS.PF_PGV:
      return getMessage('label.process.PF_PGV')
    case PROCESS.KAP:
      return getMessage('label.process.KAP')
    case PROCESS.FACTSHEET:
      return getMessage('label.process.FACTSHEET')
    default:
      return ''
  }
}

export const getLevelOptions = (getMessage: (key: string, params?: Array<string | number>) => string) => {
  return Object.values(LEVEL).map((level) => ({
    label: getTranslationForLevel(getMessage, level),
    value: level,
  }))
}

export const getConfigStatusOptions = (
  getMessage: (key: string, params?: Array<string | number>) => string,
): Option[] => {
  return [
    { label: getTranslationForStatus(getMessage, CONFIGURATION_STATUS.ACTIVE), value: CONFIGURATION_STATUS.ACTIVE },
    { label: getTranslationForStatus(getMessage, CONFIGURATION_STATUS.INACTIVE), value: CONFIGURATION_STATUS.INACTIVE },
  ]
}

export const getOptionsForFilter = (restOptions: Option[]) => {
  const options: Option[] = []

  options.push({ label: '', value: null })
  options.push(...restOptions)

  return options
}
